import { PropsWithChildren } from "react";

import { Box } from "@mui/material";
import { useAlertContext } from "@shared";

import { useTranslation } from "@/translations";

export function NotImplementedWrapper({ children }: PropsWithChildren) {
  const { showWarning } = useAlertContext();
  const { t } = useTranslation();

  return (
    <Box component="span" onClick={() => showWarning(t("common.notImplemented"))} sx={{ display: "contents" }}>
      {children}
    </Box>
  );
}
